"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _default = {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    isExternal: function isExternal() {
      return (0, _validate.isExternal)(this.to);
    },
    type: function type() {
      if (this.isExternal) {
        return 'a';
      }
      return 'router-link';
    }
  },
  methods: {
    linkProps: function linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          rel: 'noopener'
        };
      }
      return {
        to: to
      };
    }
  }
};
exports.default = _default;